import React, { useEffect } from 'react'
import { userBehaviourConfigurationsAtom } from '../UserBehaviourConfig'
import { useAtom } from 'jotai'

const UserBehaviourInspectorConfig = ({ aggregator }) => {
  const [config, setConfig] = useAtom(userBehaviourConfigurationsAtom)

  const updateInspectorConfig = (property, value) => {
    setConfig((prevState) => {
      const newInspectorConfig = { ...prevState.inspectorConfig }
      newInspectorConfig[property] = value
      return {
        ...prevState,
        inspectorConfig: newInspectorConfig
      }
    })
  }

  useEffect(() => {
    if (aggregator && !config.inspectorConfig) {
      updateInspectorConfig("aggregateProperty", aggregator.timeseriesKeys[0])
    }
  }, [aggregator])

  return (
    <></>
  )
}

export default UserBehaviourInspectorConfig